import React from 'react';
import { Col, Row } from 'antd';
import { useRateCardCreationContext } from './_rates-long-term-context';
import { ContentContainer, Text } from '@common/components';
import { RatesLongTermStepSummaryAffectedItems } from './_rates-long-term-step-summary-affected-items';
import { RatesLongTermStepSummaryRateCard } from './_rates-long-term-step-summary-rate-card';

export function LongTermRateStepConfirmRateUpdates() {
  const { rateCardAttributes, selectedOrganizationUnits } =
    useRateCardCreationContext();

  return (
    <div className="rate-cards-review-and-save">
      <ContentContainer title="Review Update">
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Text bold>Rate Card</Text>
            <RatesLongTermStepSummaryRateCard
              rateCardAttributes={rateCardAttributes}
            />
          </Col>
          <Col span={12}>
            <Text bold>Affected Items</Text>
            <RatesLongTermStepSummaryAffectedItems
              rateCardAttributes={rateCardAttributes}
              selectedOrganizationUnits={selectedOrganizationUnits}
            />
          </Col>
        </Row>
      </ContentContainer>
    </div>
  );
}
